import { render, staticRenderFns } from "./chart6.vue?vue&type=template&id=16606dc4&scoped=true&"
import script from "./chart6.vue?vue&type=script&lang=js&"
export * from "./chart6.vue?vue&type=script&lang=js&"
import style0 from "./chart6.vue?vue&type=style&index=0&id=16606dc4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16606dc4",
  null
  
)

export default component.exports